import React from 'react';

export default function Tag({icon, text}) {
  return (
    <div className="tag badge label-2 d-inline-flex align-items-center bg-light text-info lh-1">
      <span className="material-icons fs-5 me-1">{icon}</span>
      {text}
  </div>
  )
}
